import { render, staticRenderFns } from "./Sview.vue?vue&type=template&id=354a9d9e"
import script from "./Sview.vue?vue&type=script&lang=js"
export * from "./Sview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports